import FullWidthLayout from "@/layouts/FullWidthLayout";
import OutboundFreightTable from "kinnect-front/Warehouse/OutboundFreight/OutboundFreightTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";
import { OutboundFreight } from "kinnect-models";

export default {
	name: "OutboundFreightRequestsPage",

	metaInfo: { title: "Warehouse - Outbound Freight Requests" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		items: [],
		search: "",
		outboundFreightIncludes: [
			"address",
			"carrier",
			"customer",
			"sales-orders",
			"salesman.user",
			"statuses",
			"statuses.user-set-by",
			"user-assigned"
		]
	} ),

	computed: {
		filteredItems() {
			return this.items.filter( item => item.$.status === "UNAPPROVED" );
		},

		numItems() {
			return this.filteredItems.length;
		}
	},

	watch: {
		numItems( numItems ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numItems} requests` );
		}
	},

	methods: {
		async fetchItems() {
			this.items = await OutboundFreight
			.where( "approved", false )
			.include( this.outboundFreightIncludes )
			.get();
		},

		async fetch() {
			await this.fetchItems();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<OutboundFreightTable
					hiddenCols="statusText"
					items={this.filteredItems}
					loading={this.$wait.is( "get outbound freight list" )}
					search={this.search}
				></OutboundFreightTable>
			</VCard>
		</FullWidthLayout>;
	}
};
